import React from 'react';

import logo from './images/FindMe2careLogo.svg'

import styles from './Logo.module.css';

const Logo = (props) => {
  return <img src={logo} className={styles.logo} alt="logo" />
}

export default Logo;